import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  TabContent, TabPane, Nav, NavItem, NavLink
} from 'reactstrap';
import classnames from 'classnames';
import ReligionList from '../Religion/ReligionList';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import StudentPage from '../../views/StudentPage';

class Caste extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			casName : '',
			communi : '',
			relName : '',
			_message : '',
			value : '',
			alertClass :'',
			_redirect : false,
			posts : [],
			postFilter : [],
			activeTab: '1',
			castename : '',
			commun : [],
			commu : '',
			currentPage: 1,
			todosPerPage: 20,
			activePage : 1,
			filteralert : 1
		}
		this.basestate = this.state;
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onRelSubmit = this.onRelSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.toggle = this.toggle.bind(this);
		this.onClick = this.onClick.bind(this);
		this.relClick = this.relClick.bind(this);
		this.onSearchChange = this.onSearchChange.bind(this);
		this.onSearChange = this.onSearChange.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onShowChange = this.onShowChange.bind(this);
	}
	
	onShowChange(e){
		
		if(this.state.filteralert == 1){
			this.state.todosPerPage = e.target.value;
			this.getcasdata();
		}
		else
		{
			this.state.todosPerPage = e.target.value;
		    this.filterdata();
		}
		console.log(this.state);
	}
	
	handlePageChange(pageNumber) {
		
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	}
  
	onSearChange(e){
		
		this.state.commu = e.target.value;
		this.filterdata();
	}
	
	onSearchChange(e){
		
		this.state.castename = e.target.value;
		this.filterdata();
	}
	
	toggle(tab) {
		if (this.state.activeTab !== tab) {
		  this.setState({
			activeTab: tab
		  });
		}
	}
	
	/** reset caste form **/
	onClick(e){
		
		document.getElementById("casform").reset();
	}
	
	/** reset religion form **/
	relClick(e){
		
		document.getElementById("relform").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** submit caste form **/
	onSubmit(e){
		e.preventDefault();
		
		 $("#showLoader").show();
		if(this.state.casName && this.state.communi){
			
			PostData('caste/addcaste',this.state).then((result) => {
				 $("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Caste has been Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("casform").reset();
					this.getcasdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	/** submit religion form **/
	onRelSubmit(e){
		e.preventDefault();
		 $("#showLoader").show();
		if(this.state.relName){
			
			PostData('caste/addreligion',this.state).then((result) => {
				 $("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Religion has been Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("relform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	/** remove function **/
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 
           $("#showLoader").show();		
			PostData('caste/deletecaste',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Caste Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getcasdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Caste',
						alertClass:'alert alert-danger'
					});
				}
			});
		}		
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
	/** this function will be call when page loading **/
	componentWillMount() {
		 
		this.getcasdata();
		this.getcommunity();
		//$('#show option').eq(1).prop('selected', true).trigger('change');
	}
	
	getcasdata(){
		$("#showLoader").show();
		GetData('caste/getcas').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson,
					postFilter : responseJson
				});
				
			}
		});
	}
	
	/** get Community **/
	getcommunity(){
		$("#showLoader").show();
		GetData('caste/getcommunity').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					commun : responseJson
				});
			}
		});
	}
	
	filterdata(){
		
		this.setState({filteralert: 2});
		this.state.postFilter = [];
		var dat = [];
		for(var i=0; i<this.state.posts.length; i++){
			
			if(this.state.castename!='' && this.state.commu!=''){
				if(this.state.posts[i].caste.toLowerCase().search(this.state.castename.toLowerCase()) !=-1 && this.state.posts[i].community ==this.state.commu){
				
					dat.push(this.state.posts[i]);
				}
			}
			else if(this.state.castename!='' && this.state.commu==''){
				if(this.state.posts[i].caste.toLowerCase().search(this.state.castename.toLowerCase()) !=-1){
				
					dat.push(this.state.posts[i]);
				}
			}
			else if(this.state.commu!='' && this.state.castename==''){
				if(this.state.posts[i].community ==this.state.commu){
				
					dat.push(this.state.posts[i]);
				}
			}
			
		}
		this.setState({postFilter : dat});
	}
	
	
  render() {
	
	if(this.state._redirect){
		  
		return (<Redirect to={'/settings/casteupdate/' + this.state.idd} />);

	}
	
	 var com = this.state.commun;
	 
	 /** set showcount select box **/
	this.shows = [
		
		{value : '20', name : '20'},
		{value : '10', name : '10'},
		{value : '50', name : '50'},
		{value : '100', name : '100'}
	];
		
	// Logic for displaying current todos
	const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
	const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
	const currentTodos = this.state.postFilter.slice(indexOfFirstTodo, indexOfLastTodo);

	 const renderTodos = currentTodos.map((item,i) => {
	  return <tr key = {item}>
				<td>{i+1}</td>
				<td>{item.caste}</td>
				<td>{item.comm}</td>
				<td>
					<button name="editacyear" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} data-toggle="tooltip" data-placement="top" title="Edit"><i className="fa fa-edit"></i></button>
					&nbsp;&nbsp;
					<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} data-toggle="tooltip" data-placement="top" title="Delete "><i className="fa fa-remove"></i></button>
				</td>
			</tr>; 
	});
	
    return (
		<div>
		  <StudentPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			<Row>
			  <Col md="12">
				<Nav tabs>
				  <NavItem>
					<NavLink
					  className={classnames({ active: this.state.activeTab === '1' })}
					  onClick={() => { this.toggle('1'); }}
					>
					  Student caste
					</NavLink>
				  </NavItem>
				  <NavItem>
					<NavLink
					  className={classnames({ active: this.state.activeTab === '2' })}
					  onClick={() => { this.toggle('2'); }}
					>
					  Student Religion
					</NavLink>
				  </NavItem>
				</Nav>
				<TabContent activeTab={this.state.activeTab}>
				  <TabPane tabId="1">
					<Row>
					  <Col md="1">
						Caste :
					  </Col>
					  <Col md="2">
						<Input type="text" name="castename" required onChange={this.onSearchChange} />
					  </Col>
					  <Col md="1">
						Community:
					  </Col>
					  <Col md="2">
						<select name="commu" onChange={this.onSearChange} className="form-control" >
							<option value="">Select</option>
							{
								com.map(function (item) {
									return <option value={item.id}>{item.community}</option>;
								})
							}
						</select>
					  </Col>
					  <Col md="2">
						Total Caste : <span>{this.state.postFilter.length}</span>
					  </Col>
					  <Col md="2">
						show &nbsp;
							<select name="show" id="show" onChange={this.onShowChange} >
								{this.shows.map((e, key) => {
									return <option key={key} value={e.value}>{e.name}</option>;
								})}	
							 </select>&nbsp;
						entries
					  </Col>
					</Row><br></br>
					<Row>
					<Col md="8">
						<Table responsive bordered>
							<thead>
								<tr>
									<th>S.No</th>
									<th>Caste</th>
									<th>Community</th>
									<th width="100">Manage</th>
								</tr>
							</thead>
							<tbody>
								{renderTodos}
								<br></br>
								<Pagination
								 activePage={this.state.activePage}
								 itemsCountPerPage={this.state.todosPerPage}
								 pageRangeDisplayed={3}
								 totalItemsCount={this.state.postFilter.length}
								 onChange={this.handlePageChange}
								/>
							</tbody>
						</Table>
					</Col>
					<Col md="4">
					<Card>
					  <form action="" method="post" role="form" id="casform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader className="card-header-inner">
							<strong>Add Caste</strong>
						</CardHeader>
						<CardBody>
						  <Row>
							<Col md="12">
							 <Row>
								<Col md="4">
								  <FormGroup>
									<Label htmlFor="name">Caste Name</Label>
								  </FormGroup>
								</Col>
								<Col md="8">
								  <FormGroup>
								   <Input type="text" name="casName" id="name" required onChange={this.onChange} />
								  </FormGroup>
								</Col>
							 </Row>
							</Col>
							<Col md="12">
							 <Row>
								<Col md="4">
								  <FormGroup>
									<Label htmlFor="name">Community</Label>
								  </FormGroup>
								</Col>
								<Col md="8">
								  <FormGroup>
									<select name="communi" className="form-control" onChange={this.onChange} required>
									<option value="">Select</option>
										{
											com.map(function (item) {
												return <option value={item.id}>{item.community}</option>;
											})
										}
								  </select>
								</FormGroup>
								</Col>
							 </Row>
							</Col>
						  </Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary" ><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
					</Col>
					</Row>
				  </TabPane>
				  <TabPane tabId="2">
					<Row>
					<Col md="6">
					<Card>
					  <form action="" method="post" role="form" id="relform" encType="multipart/form-data" onSubmit={this.onRelSubmit} >
						<CardHeader className="card-header-inner">
							<strong>Add Religion</strong>
						</CardHeader>
						<CardBody>
						  <Row>
							<Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Religion Name</Label>
								  <Input type="text" name="relName" id="name" required onChange={this.onChange} />
								</FormGroup>
							</Col>
						  </Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.relClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
					</Col>
					<Col md="6">
						<ReligionList />
					</Col>
					</Row>
				  </TabPane>
				</TabContent>
			  </Col>
			</Row>
			</div>
		</div>
	);
  }
}

export default Caste;


// WEBPACK FOOTER //
// ./src/settings/Caste/Caste.js